// src/App.js
import React, { useState, useEffect } from "react";
import { scrollSpy } from "react-scroll";
import "bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import About from "./pages/About";
import ContactUs from "./pages/ContactUs";
import LoginForm from "./components/LoginForm";
import Display from "./pages/Display";
// App-wide styles (table headers, custBtn, custom_input, progress bars, buttons). They used to be loaded
// by the old upload page, which is gone, so they are loaded here in the same place
import "./pages/UploadExcel.css";
import InstDashboardMain from "./pages/dashboards/ResolutionDashboard/InstDashboardMain";
import { Box, Typography, Button } from "@mui/material";
import "./App.css";
import InstDashboard from "./pages/dashboards/ResolutionDashboard/InstDashboard";
import AssignArbitrator from "./pages/AssignArbitrator";
import ReferenceDraftServices from "./pages/ReferenceDraftServices";
import ReferenceDraftReports from "./pages/ReferenceDraftReports";
import ReferenceDraftGenerate from "./pages/ReferenceDraftGenerate";
import ArbDashboard from "./pages/ArbDashboard";
import ArbDashboardMain from "./pages/dashboards/ArbitratorDashboard/ArbDashboardMain";
import AcceptanceLetter from "./pages/AcceptanceLetter";
import AcceptanceLetterService from "./pages/AcceptanceLetterService";
import AcceptanceLetterReports from "./pages/AcceptanceLetterReports";
import VirtualMeeting from "./pages/VirtualMeeting";

import Section17Order from "./pages/Section17Order";
import Sec17Order from "./pages/section17Order/Sect17Order";
import CaseTrackingLotwise from "./pages/caseTracking/CaseTrackLotwise";
import CaseTrackingCasewise from "./pages/caseTracking/CaseTrackCasewise";
import LawyerDashboard from "./pages/dashboards/AcumenDashboard/LawyerDashboard";
import LawyerDashboardMain from "./pages/LawyerDashboardMain";
import SOC from "./pages/SOC";
import Section17Application from "./pages/Section17Application";
import ITDashboard from "./pages/ITDashboard";
import ITDashboardMain from "./pages/ITDashboardMain";
import ArbInfo from "./pages/ArbInfo";
// App-wide .form-container style (used by the hearing file-upload form), formerly loaded by the old Bank Info page
import "./pages/Bank.css";
import BanksProducts from "./pages/banks/BanksProducts";
import AssignSecondHearingDate from "./pages/AssignSecondHearingDate";
import AssignThirdHearingDate from "./pages/AssignThirdHearingDate";

import Terminate from "./pages/Terminate";
// import SecondHearingNotice from "./pages/SecondHearingNotice";
import SecondHearingNotice from "./pages/firstHearing/SecondHearingNotice";
import AwardPass from "./pages/AwardPass";
import VirtualMeetingForSecondHearing from "./pages/VirtualMeetingForSecondHearing";
import VirtualMeetingForThirdHearing from "./pages/VirtualMeetingForThirdHearing";

import ThirdHearingNotice from "./pages/ThirdHearingNotice";
// import SecondHearingServices from "./pages/SecondHearingServices";
import SecondHearingReport from "./pages/SecondHearingReport";
import ThirdHearingServices from "./pages/ThirdHearingServices";
import ThirdHearingReport from "./pages/ThirdHearingReport";

import UploadedLotList from "./pages/UploadedLotList";
import AccScheduledMeets from "./pages/AccScheduledMeets";
import ZoomMeetings from "./pages/ZoomMeetings";
import Sec17OrderData from "./pages/Section17OrderData";
import Section17OrderService from "./pages/Section17OrderService";
import Section17OrderReports from "./pages/Section17OrderReports";
import Section17ApplicationData from "./pages/Section17ApplicationData";
import SOCData from "./pages/SOCData";
import AwardPassLotwise from "./pages/awardPass/GenerateAward";
import AwardPassCasewise from "./pages/AwardPassCasewise";
import "react-datepicker/dist/react-datepicker.css";
import SignedAccUpload from "./pages/SignedAccUpload";
import SignedSec17Order from "./pages/SignedSec17Order";
import Arbitrator from "./pages/arbitrator/Arbitrator";
import UploadLot from "./pages/lots/UploadLot";
import ArbitratorDashboard from "./pages/dashboards/ArbitratorDashboard/ArbitratorDashboard";
import FirstHearing from "./pages/firstHearing/FirstHearing";
import FirstHearingRoznama from "./pages/firstHearing/FirstHearingRoznama";
import SecondHearing from "./pages/secondHearing/SecondHearing";
import SecondHearingRoznama from "./pages/secondHearing/SecondHearingRoznama";
import SecondHearingServices from "./pages/firstHearing/SecondHearingServices";
import TerminateCase from "./pages/terminate/TerminateCase";
import HoldCase from "./pages/hold/HoldCase";
import UploadSOC from "./pages/soc/UploadSOC";
import AccLtrReports from "./pages/acceptanceLetter/AccLtrReports";
import GenerateAccLtr from "./pages/acceptanceLetter/GenerateAccLtr";
import SecondHearingReports from "./pages/firstHearing/SecondHearingReports";
import ThirdHearingNoticee from "./pages/secondHearing/ThirdHearingNotice";
import ThirdHearingService from "./pages/secondHearing/ThirdHearingService";
import ThirdHearingReports from "./pages/secondHearing/ThirdHearingReports";
import ThirdHearingRoznama from "./pages/thirdHearing/ThirdHearingRoznama";
import Pursis from "./pages/pursis/Pursis";
import ContestedCases from "./pages/contested/ContestedCases";
import AppointmentLtrServices from "./pages/appointmentLetter/AppointmentLtrServices";
import AppointmentLtrReports from "./pages/appointmentLetter/AppointmentLtrReports";
import GenerateAppointmentLtr from "./pages/appointmentLetter/GenerateAppointmentLtr";
import AccLtrServices from "./pages/acceptanceLetter/AccLtrServices";
import Sect17OrderServices from "./pages/section17Order/Sect17OrderServices";
import Sect17OrderReports from "./pages/section17Order/Sect17OrderReports";
import Sect17Application from "./pages/sec17Application/Sect17Application";
import Sect17ApplicationServices from "./pages/sec17Application/Sect17ApplicationServices";
import Sect17ApplicationReports from "./pages/sec17Application/Sect17ApplicationReports";
import GenerateAward from "./pages/awardPass/GenerateAward";
import BankDashboard from "./pages/dashboards/forBankDashboard/BankDashboard";
import BankDashboardMain from "./pages/dashboards/forBankDashboard/BankDashboardMain";
import AwardService from "./pages/awardPass/AwardService";
import AwardReports from "./pages/awardPass/AwardReports";
import SOCService from "./pages/soc/SOCService";
import SOCReports from "./pages/soc/SOCReports";
import CreateZoomMeets from "./pages/zoomMeets/CreateZoomMeets";
import ZoomMeetList from "./pages/zoomMeets/ZoomMeetList";
import ServiceReports from "./pages/serviceReports/ServiceReports";
import CaseTrackingCaseWise1 from "./pages/caseTracking/CaseTrackCasewise1";
import MisSheet from "./pages/mis/MisSheet";
import CaseFileManager from "./pages/public/CaseFileManager";
import HearingLinkRedirect from "./pages/public/HearingLinkRedirect";


const App = () => {
  // useEffect(() => {
  //     scrollSpy.update();
  // }, []);

  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    const consentGiven = localStorage.getItem("consentGiven");
    if (!consentGiven) {
      setIsModalOpen(true); // Open the main disclaimer modal if consent hasn't been given
    }
  }, []);

  const handleAccept = () => {
    setIsModalOpen(false);
    localStorage.setItem("consentGiven", "true");
    localStorage.setItem("cookiesConsent", "true");
  };

  const handleDecline = () => {
    setIsModalOpen(false);
    localStorage.setItem("consentGiven", "true");
    localStorage.setItem("cookiesConsent", "false");
  };

  return (
    <div>
      <Routes>
        <Route path="/login" element={<LoginForm />} />
        <Route path="/" element={<Display />} />
        <Route path="/case-files/:refNo" element={<CaseFileManager />} />
        <Route path="/RESEAA/:linkId" element={<HearingLinkRedirect />} />

        <Route path="/bankdashboard" element={<BankDashboard />}>
          <Route index element={<BankDashboardMain />} />
          <Route path="dashboard" element={<BankDashboardMain />} />
          <Route path="casetracking">
            <Route path="lotwise" element={<CaseTrackingLotwise />} />
            <Route path="casewise" element={<CaseTrackingCasewise />} />
            <Route path="casewise1" element={<CaseTrackingCaseWise1 />} />
          </Route>
          <Route path="mis" element={<MisSheet mode="resolution" />} />
          <Route path="servicereports" element={<ServiceReports />} />
        </Route>

        <Route path="/instdashboard" element={<InstDashboard />}>
          <Route index element={<InstDashboardMain />} />
          <Route path="dashboard" element={<InstDashboardMain />} />
          <Route path="arbitrator" element={<Arbitrator />} />
          <Route path="arbitratorlist" element={<Arbitrator />} />
          <Route path="addarbitrator" element={<Arbitrator />} />
          <Route path="uploadalot">
            <Route path="uploadnewlot" element={<UploadLot />} />
            <Route path="list" element={<UploadedLotList />} />
            <Route path="banks" element={<BanksProducts />} />
          </Route>
          <Route path="assignArb">
            <Route path="bysystem" element={<AssignArbitrator />} />
          </Route>
          <Route path="referencedraft">
            <Route path="generate-rd" element={<GenerateAppointmentLtr />} />
            {/* <Route path="generate-rd" element={<ReferenceDraftGenerate />} /> */}
            <Route path="services" element={<AppointmentLtrServices />} />
            {/* <Route path="services" element={<ReferenceDraftServices />} /> */}
            <Route path="reports" element={<AppointmentLtrReports />} />
            {/* <Route path="reports" element={<ReferenceDraftReports />} /> */}
          </Route>
        </Route>

        <Route path="/itdashboard" element={<ITDashboard />}>
          <Route index element={<ITDashboardMain />} />
          <Route path="dashboard" element={<ITDashboardMain />} />
          <Route path="arbitrators" element={<ArbInfo />} />
          {/* <Route path="arbitrators" element={<ArbInfo />} /> */}
          {/* <Route path="trial" element={<Trial />} /> */}
        </Route>

        <Route path="/arbdashboard" element={<ArbitratorDashboard />}>
          {/* <Route path="/arbdashboard" element={<ArbDashboard />}> */}
          <Route index element={<ArbDashboardMain />} />
          <Route path="dashboard" element={<ArbDashboardMain />} />
          <Route path="zoommeetings" element={<CreateZoomMeets />} />
          <Route path="zoommeetlist" element={<ZoomMeetList />} />
          {/* <Route path="zoommeetings" element={<ZoomMeetings />} /> */}
          <Route path="acceptletter" element={<AcceptanceLetter />} />
          <Route path="acceptletter">
            <Route path="generate_al" element={<GenerateAccLtr />} />
            {/* <Route path="generate_al" element={<AcceptanceLetter />} /> */}
            <Route path="signedaccupload" element={<SignedAccUpload />} />
            <Route path="services" element={<AccLtrServices />} />
            {/* <Route path="services" element={<AcceptanceLetterService />} /> */}
            <Route path="reports" element={<AccLtrReports />} />
            {/* <Route path="reports" element={<AcceptanceLetterReports />} /> */}
            <Route path="list" element={<AccScheduledMeets />} />
          </Route>
          {/* <Route path="Sec17Order" element={<Section17Order />} /> */}
          <Route path="section17order">
            {/* <Route path="generatesection17order" element={<Section17Order />} /> */}
            <Route path="generatesection17order" element={<Sec17Order />} />
            <Route path="signedsec17order" element={<SignedSec17Order />} />
            <Route path="services" element={<Sect17OrderServices />} />
            {/* <Route path="services" element={<Section17OrderService />} /> */}
            <Route path="reports" element={<Sect17OrderReports />} />
            {/* <Route path="reports" element={<Section17OrderReports />} /> */}
            {/* <Route path="list" element={<Section17OrderData />} /> */}
          </Route>

          <Route path="firstHearing">
            <Route path="first_Hearing" element={<FirstHearing />} />
            {/* <Route path="first_Hearing" element={<VirtualMeeting />} /> */}
            <Route
              path="firstHearingRoznama"
              element={<FirstHearingRoznama />}
            />
            <Route
              path="createSecondHearingNotice"
              element={<SecondHearingNotice />}
            />
            <Route
              path="secondHearingNoticeServices"
              element={<SecondHearingServices />}
            // element={<SecondHearingServices />}
            />
            <Route
              path="secondHearingNoticeReports"
              element={<SecondHearingReports />}
            />
            {/* <Route
              path="secondHearingNoticeReports"
              element={<SecondHearingReport />}
            /> */}
          </Route>

          <Route path="secondHearing">
            <Route
              path="second_Hearing"
              element={<SecondHearing />}
            // element={<VirtualMeetingForSecondHearing />}
            />
            <Route
              path="secondHearingRoznama"
              element={<SecondHearingRoznama />}
            />
            <Route
              path="createThirdHearingNotice"
              element={<ThirdHearingNoticee />}
            // element={<ThirdHearingNotice />}
            />
            <Route
              path="thirdHearingNoticeServices"
              element={<ThirdHearingService />}
            // element={<ThirdHearingServices />}
            />
            <Route
              path="thirdHearingNoticeReports"
              element={<ThirdHearingReports />}
            // element={<ThirdHearingReport />}
            />
          </Route>

          <Route path="thirdHearing">
            <Route
              path="third_Hearing"
              element={<VirtualMeetingForThirdHearing />}
            />
            <Route
              path="thirdHearingRoznama"
              element={<ThirdHearingRoznama />}
            />
            {/* <Route
              path="createForthHearingNotice"
              element={<ForthHearingNotice />}
            />
            <Route
              path="forthHearingNoticeServices"
              element={<ForthHearingServices />}
            />
            <Route
              path="forthHearingNoticeReports"
              element={<ForthHearingReports />}
            /> */}
          </Route>

          <Route path="contested" element={<ContestedCases />} />
          <Route path="pursis" element={<Pursis />} />

          <Route path="awardPass">
            <Route path="lotwise" element={<GenerateAward />} />
            <Route path="awardservice" element={<AwardService />} />
            <Route path="awardreport" element={<AwardReports />} />
          </Route>
          {/* <Route path="terminate" element={<Terminate />} /> */}
          <Route path="hold" element={<HoldCase />} />
          <Route path="terminate" element={<TerminateCase />} />
        </Route>

        <Route path="/lawyerdashboard" element={<LawyerDashboard />}>
          <Route index element={<LawyerDashboardMain />} />
          <Route path="dashboard" element={<LawyerDashboardMain />} />
          {/* <Route path="soc" element={<SOC />} /> */}
          <Route path="soc">
            <Route path="generatesoc" element={<UploadSOC />} />
            {/* <Route path="generatesoc" element={<SOC />} /> */}
            <Route path="services" element={<SOCService />} />
            <Route path="reports" element={<SOCReports />} />
            <Route path="list" element={<SOCData />} />
          </Route>
          <Route path="section17application">
            {/* <Route
              path="generatesection17application"
              element={<Section17Application />}
            /> */}
            <Route
              path="generatesection17application"
              element={<Sect17Application />}
            />
            <Route path="services" element={<Sect17ApplicationServices />} />
            <Route path="reports" element={<Sect17ApplicationReports />} />
            <Route path="list" element={<Section17ApplicationData />} />
          </Route>
        </Route>
      </Routes>

      {isModalOpen && (
        <Box
          sx={{
            position: "fixed",
            bottom: 0,
            left: 0,
            right: 0,
            zIndex: 1300,
            bgcolor: "#1c1c1c",
            color: "#fff",
            px: 3,
            py: 2,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            flexWrap: "wrap",
            gap: 2,
            boxShadow: "0 -2px 10px rgba(0,0,0,0.3)",
          }}
        >
          <Typography variant="body2" sx={{ flex: 1, minWidth: 240 }}>
            We use cookies to ensure you get the best experience on our website. By continuing, you agree to our{" "}
            <a href="#" style={{ color: "#fff", textDecoration: "underline" }}>
              Terms of Service
            </a>
            .
          </Typography>
          <Box sx={{ display: "flex", gap: 1.5 }}>
            <Button
              variant="contained"
              size="small"
              onClick={handleAccept}
              sx={{
                whiteSpace: "nowrap",
                bgcolor: "#EAA637",
                color: "#172639",
                fontWeight: 700,
                border: "1px solid transparent",
                "&:hover": {
                  bgcolor: "#172639",
                  color: "#EAA637",
                  border: "1px solid #EAA637",
                },
              }}
            >
              Accept
            </Button>
            <Button
              variant="outlined"
              size="small"
              onClick={handleDecline}
              sx={{
                whiteSpace: "nowrap",
                borderColor: "#EAA637",
                color: "#EAA637",
                fontWeight: 700,
                "&:hover": {
                  bgcolor: "rgba(234, 166, 39, 0.1)",
                  borderColor: "#EAA637",
                },
              }}
            >
              Decline
            </Button>
          </Box>
        </Box>
      )}
    </div>
  );
};

export default App;
